// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Raiv","dragIcon":"Choice_dragIcon__1rUNF","left":"Choice_left__1_X02","input":"Choice_input__7TQDJ"};